{
  "departamentosRegionais": [
    {
      "nome": "Santa Catarina",
      "regioes": [
        {
          "nome": "Alto Vale do Itajaí",
          "unidadesOperacionais": [
            {
              "codigo": "219",
              "nome": "219 - SESI/SC - Clínica Rio do Sul"
            }
          ]
        },
        {
          "nome": "Centro-Norte",
          "unidadesOperacionais": [
            {
              "codigo": "204",
              "nome": "204 - SESI/SC - Clínica Caçador"
            },
            {
              "codigo": "205",
              "nome": "205 - SESI/SC - Clínica Canoinhas"
            },
            {
              "codigo": "223",
              "nome": "223 - SESI/SC - Clínica Videira"
            }
          ]
        },
        {
          "nome": "Centro-Oeste",
          "unidadesOperacionais": [
            {
              "codigo": "213",
              "nome": "213 - SESI/SC - Clínica Joaçaba"
            }
          ]
        },
        {
          "nome": "Extremo Oeste",
          "unidadesOperacionais": [
            {
              "codigo": "229",
              "nome": "229 - SESI/SC - Clínica São Miguel do Oeste"
            }
          ]
        },
        {
          "nome": "Foz do Rio Itajaí",
          "unidadesOperacionais": [
            {
              "codigo": "211",
              "nome": "211 - SESI/SC - Clinica Itajaí"
            }
          ]
        },
        {
          "nome": "Litoral Sul",
          "unidadesOperacionais": [
            {
              "codigo": "222",
              "nome": "222 - SESI/SC - Clínica Tubarão"
            }
          ]
        },
        {
          "nome": "Norte-Nordeste",
          "unidadesOperacionais": [
            {
              "codigo": "214",
              "nome": "214 - SESI SC - Clinica Joinville Sul"
            }
          ]
        },
        {
          "nome": "Oeste",
          "unidadesOperacionais": [
            {
              "codigo": "206",
              "nome": "206 - SESI/SC - Clínica Chapecó"
            },
            {
              "codigo": "233",
              "nome": "233 - SESI/SC - Clínica Xanxerê"
            }
          ]
        },
        {
          "nome": "Planalto Norte",
          "unidadesOperacionais": [
            {
              "codigo": "217",
              "nome": "217 - SESI/SC - Clínica Mafra"
            },
            {
              "codigo": "221",
              "nome": "221 - SESI/SC - Clínica São Bento do Sul I"
            }
          ]
        },
        {
          "nome": "Serra Catarinense",
          "unidadesOperacionais": [
            {
              "codigo": "215",
              "nome": "215 - SESI/SC - Clínica Lages"
            }
          ]
        },
        {
          "nome": "Sudeste",
          "unidadesOperacionais": [
            {
              "codigo": "209",
              "nome": "209 - SESI/SC - Clínica São José"
            }
          ]
        },
        {
          "nome": "Sul",
          "unidadesOperacionais": [
            {
              "codigo": "208",
              "nome": "208 - SESI/SC - Clinica Criciuma"
            },
            {
              "codigo": "216",
              "nome": "216 - SESI/SC - Clínica Orleans"
            }
          ]
        },
        {
          "nome": "Vale do Itajaí",
          "unidadesOperacionais": [
            {
              "codigo": "2019",
              "nome": "2019 - SESI/SC - Clínica Indaial"
            },
            {
              "codigo": "235",
              "nome": "235 - SESI/SC - Clínica Blumenau"
            }
          ]
        },
        {
          "nome": "Vale do Itapocu",
          "unidadesOperacionais": [
            {
              "codigo": "212",
              "nome": "212 - SESI/SC - Clínica Jaraguá do Sul"
            }
          ]
        }
      ]
    }
  ]
}
